import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface AddColumnHeaderParams {
  readonly onAddColumn: () => void;
}

type AddColumnHeaderComponentParams = IHeaderParams & AddColumnHeaderParams;

@Component({
  selector: 'dojo-add-column-header',
  templateUrl: './add-column-header.component.html',
  styleUrl: './add-column-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddColumnHeaderComponent implements IHeaderAngularComp {
  private params!: AddColumnHeaderComponentParams;

  agInit(params: AddColumnHeaderComponentParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return true;
  }

  addColumn(): void {
    this.params.onAddColumn();
  }
}
